import React, { useState } from 'react';
import LoginHeader from "../../../layouts/LoginHeader.component";
import Sidebar_Progress from "../../../layouts/Operational_Sidebar_Progress.component";
import customer from '../../../../img/customer-review.png'
import ReactDOM from 'react-dom';
import { API_URL } from "../../../../constant/API_Settings";
import swal from "sweetalert";
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';

import ManagerLoginHeader from '../ManagerLoginHeader.component'
import Switch from "react-switch";
import { getStoredPermissions } from "../../../../utils/permissions";
import { applyCheckUrlNavigation } from '../../../../utils/checkUrlNavigation';

const NotificationSetting = (props) => {

	let permissions = getStoredPermissions();

	const history = useHistory()
	const [search, setSearch] = useState('')
	const [list_data, setList] = useState([])
	const [checked, setchecked] = useState(false)
	const [criticalLitres, setCriticalLitres] = useState('100')
	const [litresMessage, setLitresMessage] = useState('')

	//---On Load---//		
	useEffect(() => {
		check_url()

	}, [search]);
	function check_url() {
		const requestOptions = {
			method: 'post',
			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"
			},
			body: JSON.stringify({
				pathurl: window.location.pathname,
			}),
		};
		fetch(`${API_URL}/check_url`, requestOptions)
			.then(response => { return response.json(); })

			.then(responseData => {

				applyCheckUrlNavigation(history, responseData, window.location.pathname, () => {
					ListNotiSetting()
				});

				return responseData;
			})
			.catch(e => {
				console.log(e)
			});

	}
	function ListNotiSetting() {
		const requestOptions = {      //---employee listing---//
			method: 'get',
			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"

			},
		};
		fetch(`${API_URL}/notification_setting_list`, requestOptions)
			.then(response => { return response.json(); })
			.then(responseData => {

				setList(responseData.data)
				if (responseData.critical_fuel_litres !== undefined && responseData.critical_fuel_litres !== null) {
					setCriticalLitres(String(responseData.critical_fuel_litres))
				}

				return responseData;
			})
			.catch(e => {


			});
	}

	function handleChange(e, i) {
		console.log(e)
		console.log(i)
		const selected = [...list_data]
		console.log(selected)
		selected[i].status = e ? "Yes" : "No"
		const requestOptions = {      //---employee listing---//
			method: 'post',
			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"

			},
			body: JSON.stringify({
				meta_name: selected[i].name,
				meta_value: selected[i].status
			})
		};
		fetch(`${API_URL}/update_notification_setting`, requestOptions)
			.then(response => { return response.json(); })
			.then(responseData => {

				return responseData;
			})
			.catch(e => {


			});

		//	setList(selected)
		ListNotiSetting();
	}

	function saveCriticalLitres() {
		setLitresMessage('')
		const requestOptions = {
			method: 'post',
			headers: {
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				"Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
				"Accept": "application/json"
			},
			body: JSON.stringify({
				litres: criticalLitres
			})
		};
		fetch(`${API_URL}/update_critical_fuel_litres`, requestOptions)
			.then(response => { return response.json(); })
			.then(responseData => {
				if (responseData.status) {
					setCriticalLitres(String(responseData.critical_fuel_litres))
					setLitresMessage('Saved')
				} else {
					swal("", responseData.message || "Could not save the alert level", "warning")
				}
			})
			.catch(() => {
				swal("", "Could not save the alert level", "warning")
			});
	}


	return (
		<>
			<div className="main-container page-wrap">
				<div className="d-md-flex">
					<Sidebar_Progress props={props} />
					<div className="content-area">
						<ManagerLoginHeader props={props} page_title="Notification Settings" />

						<div className="container pb-3">
						{permissions.includes("Notification Settings") == false ?
	<div  className="form-wrap mt-5">
  <div className="text-center">
You don't have permission to access this page
  </div></div>:
							<div className="row justify-content-center mt-md-5 mt-3 form-container">

								<div className="col-md-10">


									<div className="form-wrap py-3 ">
										<div className="row align-items-center">
											<div className="col-5">
												<label className="col-form-label mx-3 mb-2" htmlFor="critical-fuel-litres">Critical fuel stock (litres)</label>
											</div>
											<div className="col-5 d-flex align-items-center">
												<input
													id="critical-fuel-litres"
													type="number"
													min="0"
													max="1000000"
													step="1"
													className="form-control"
													style={{ maxWidth: "160px" }}
													value={criticalLitres}
													onChange={(event) => {
														setCriticalLitres(event.target.value)
														setLitresMessage('')
													}}
												/>
												<button
													type="button"
													className="btn btn-primary ms-2"
													style={{ width: "auto", height: "40px", fontSize: "14px", padding: "0 16px" }}
													onClick={saveCriticalLitres}
												>
													Save
												</button>
											</div>
										</div>
										<small className="d-block mx-3 mb-3 text-muted">
											Default is 100 L. An alert is sent when a fuel's stock is below this level. A new alert is not added while an unread one for that fuel is already in the list. Set 0 to turn this alert off.
										</small>
										{litresMessage ? <small className="d-block mx-3 mb-3">{litresMessage}</small> : null}

										{
											list_data.map((arr, i) => {
												return (<React.Fragment key={`notif-${arr.id || arr.label || i}`}>
													<div className='row '>
														<div className='col-5'>
															<label className=" col-form-label mx-3  mb-2">{arr.label}</label>
														</div>
														<div className="col-5">
															<Switch onChange={(e) => handleChange(e, i)} checked={arr.status === "Yes"} /></div></div><br /></React.Fragment>)

											})
										}

									</div>
								</div>
							</div>}
						</div>
					</div>
				</div>
			</div>

		</>
	)
}








export default NotificationSetting